import { HttpEventType } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { NzImage, NzImageService } from 'ng-zorro-antd/image';
import { NzModalService } from 'ng-zorro-antd/modal';
import { BaseComponent } from '../base/base-component/base-component.component';
import { MediaObject, MediaStructure } from '../interfaces/MediaStructure';
import { AppConfigService } from '../services/app-config.service';
import { DomSanitizer } from '@angular/platform-browser';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { concatMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-extended-media-holder',
  templateUrl: './extended-media-holder.component.html',
  styleUrls: ['./extended-media-holder.component.less'],
})
export class ExtendedMediaHolderComponent
  extends BaseComponent
  implements OnInit {
  // imageSrc: any;
  @Input() mediaStructures: MediaStructure[] = [];
  @Input() IsMain: boolean;
  @Input() ObjectType: number;
  @Input() AttributeId: string | number;
  _objectKey: number;
  @Input() set ObjectKey(key: number) {
    this._objectKey = key;
    if (key != null) {
      setTimeout(() => {
        this.GetMediaAttributeValue();
      }, 200);

    }
  }
  get ObjectKey() {
    return this._objectKey;
  }
  @Input() attributeType: string;

  @Output() fileUploaded = new EventEmitter();
  @Output() fileRomoved = new EventEmitter();

  covertUrl: string;
  coverID: string;
  hideSlider: boolean;
  imagesMedia: MediaStructure[] = [];
  ImagesCover: MediaStructure[];
  filesMedia: MediaStructure[];
  fileRowCount: number;
  size: number;
  drawerVisible: boolean;
  base64Str: string;
  linkType: string;
  mediaLink: string;
  linkTitle: string;
  linkRols: string[];
  videoDesciption: string;
  constructor(
    injector: Injector,
    private nzImageService: NzImageService,
    private modal: NzModalService,
    private satitizer: DomSanitizer
  ) {
    super(injector);
  }

  ngOnInit(): void {


    this.coverID = '0';
    this.linkType = 'I';
    this.drawerVisible = false;
    this.hideSlider = false;
    const savedSize = localStorage.getItem('MediaSize');
    if (savedSize !== undefined && savedSize !== null) {
      this.size = Number(savedSize);
    } else {
      this.size = 150;
    }
    this.subscriptions.push(
      this.mediaService.submitMedia$.subscribe(() => {
        this.SaveObjectMedia();
      })
    );
    // localStorage.removeItem('mediaStorge');

  }


  GetMediaAttributeValue() {
    let key = `mediaStorge-${this.AttributeId}`;
    const savedMedia = localStorage.getItem(key);
    if (savedMedia === null) {
      this.subscriptions.push(
        this.mediaService
          .getMediaAttributeValue(
            this.AttributeId,
            this.ObjectType,
            this.ObjectKey
          )
          .subscribe((data: any) => {
            let RealDate: MediaObject[] = data;
            this.mediaStructures = [];
            this.imagesMedia = [];
            this.ImagesCover = [];
            this.filesMedia = [];

            RealDate.forEach((media) => {
              const tmpUploadFile: MediaStructure = {
                id: '11',
                fileID: '2',
                name: 'test',
                data: '',
                thumbData: '',
                previewData: '',
                type: '',
                originalName: '',
                extension: '',
                appInfo: '',
                isUploading: false,
                AltText: '',
                width: 0,
                height: 0,
                FileSize: 0,
                mediaLink: '',
                isHidden: false,
                isLink: false,
                HightPercent: 0,
                TopPercent: 0,
                widthPercent: 0,
                leftPercent: 0,
                Roles: [],
              };

              const id = media.id;
              tmpUploadFile.id = id.toString();

              const FileId = media.fileId;
              tmpUploadFile.fileID = FileId.toString();

              const Type = media.type;
              tmpUploadFile.type = Type;

              const AppInfo = media.appInfo;
              tmpUploadFile.appInfo = AppInfo;

              const Postion = media.postion;
              tmpUploadFile.Position = Number(Postion);

              const name = media.fileName;
              tmpUploadFile.originalName = name;

              const extension = media.fileExtension;
              tmpUploadFile.extension = extension;

              const data = media.data;

              if (data !== undefined && data !== null) {
                tmpUploadFile.data = data.toString();
              } else {
                tmpUploadFile.data = '';
              }
              const MediaLink = media.mediaLink;
              tmpUploadFile.mediaLink = MediaLink;
              const isLink = media.isLink;
              tmpUploadFile.isLink = Boolean(isLink);
              if (!tmpUploadFile.isLink) {
                tmpUploadFile.thumbData = 'data:' + Type + ';base64,' + data;
              } else {
                tmpUploadFile.thumbData = data;
              }



              const size = media.fileSize;
              tmpUploadFile.FileSize = Number(size);

              const width = media.width;
              tmpUploadFile.width = Number(width);
              const Height = media.height;
              tmpUploadFile.height = Number(Height);

              const isHidden = media.isHidden;
              tmpUploadFile.isHidden = Boolean(isHidden);

              const isVideo = media.isVideo;
              tmpUploadFile.isVideo = Boolean(isVideo);

              const altText = media.altText;
              tmpUploadFile.AltText = altText;
              //tmpUploadFile.fullPath = media.fullPath;



              const Roles = media.roles;
              if (Roles !== null && Roles !== undefined) {
                tmpUploadFile.Roles = Roles.split(',');
              }

              if (tmpUploadFile.height >= tmpUploadFile.width) {
                tmpUploadFile.HightPercent = 100;
                tmpUploadFile.widthPercent =
                  (tmpUploadFile.width * 100) / tmpUploadFile.height;
                tmpUploadFile.leftPercent =
                  (tmpUploadFile.HightPercent - tmpUploadFile.widthPercent) / 2;
                tmpUploadFile.TopPercent = 0;
              } else {
                tmpUploadFile.widthPercent = 100;
                tmpUploadFile.HightPercent =
                  (tmpUploadFile.height * 100) / tmpUploadFile.width;
                tmpUploadFile.TopPercent =
                  (tmpUploadFile.widthPercent - tmpUploadFile.HightPercent) / 2;
                tmpUploadFile.leftPercent = 0;
              }
              tmpUploadFile.Percent = 100;
              tmpUploadFile.isUploading = false;
              tmpUploadFile.isError = false;

              this.mediaStructures.push(tmpUploadFile);

            });

            from(RealDate).pipe(
              concatMap((media, index) => {
                if (media.md5) {
                  return this.mediaService.getMediaByMd5(media.md5).pipe(
                    tap((blob: Blob) => {

                      const target = this.mediaStructures[index];
                      target.fullPath = this.productCatalogService.createImageUrl(blob);

                    })
                  );
                }
                return of(null);
              })
            ).subscribe();

            
            this.imagesMedia = this.mediaStructures.filter(
              (x) =>
                (x.type.startsWith('image') || x.type.startsWith('link')) &&
                x.isHidden !== true
            );

            this.filesMedia = this.mediaStructures.filter(
              (x) =>
                !x.type.startsWith('image') &&
                !x.type.startsWith('link') &&
                x.isHidden !== true
            );

            this.ImagesCover = this.mediaStructures.filter(
              (x) => x.type.startsWith('image') && x.isHidden === true
            );
          })
      );
    } else {

      this.loadMediaFromLocalStorage();
    }
  }


  SaveObjectMedia() {
    if (this.ObjectKey == null) {
      return;
    }
    this.mediaService.updateAttributeMedia(
      this.AttributeId.toString(),
      this.ObjectType,
      this.ObjectKey,
      this.mediaStructures
    );
  }

  SaveObjectMediaBulk() {
    if (this.ObjectKey == null) {
      return;
    }
    this.mediaService.updateAttributeMedia(
      this.AttributeId.toString(),
      this.ObjectType,
      this.ObjectKey,
      this.mediaStructures
    );
  }

  drop(event: any) {
    // moveItemInArray(this.imagesMedia, event.previousIndex, event.currentIndex);
  }

  Download(mediaStrucure: MediaStructure) {
    const link = `${AppConfigService.settings.apiUrl}Media/DownloadMedia?mediaID=${mediaStrucure.fileID}`;

    window.open(link);
  }
  removeFile(mediaStrucure: MediaStructure) {
    this.modal.confirm({
      nzTitle: this.layoutService.translate(
        'Are you sure you want to remove this Media?'
      ),
      nzOkText: this.layoutService.translate('Yes'),
      nzCancelText: this.layoutService.translate('No'),

      nzOnOk: () => {
        if (mediaStrucure.isImage) {      
          this.imagesMedia = this.imagesMedia.filter(
            (z) => z.id !== mediaStrucure.id
          );
        } else {
          this.filesMedia = this.filesMedia.filter(
            (w) => w.id !== mediaStrucure.id
          );
        }
        if (mediaStrucure.id != '0') {

          this.subscriptions.push(
            this.mediaService.RemoveMedia(mediaStrucure, this.ObjectKey).subscribe((x: any) => {
              this.mediaStructures = this.mediaStructures.filter(
                (z) => z.id !== mediaStrucure.id
              );
              // this.resetMediaStorageKeys();
            })
          );
        }

        this.fileRomoved.emit(mediaStrucure.id);

        this.resetMediaStorageKeys();
        return true;
      },
    });
  }


  parentPreview(mediaStrucure: MediaStructure) {

    if (mediaStrucure.isImage) {
      this.nzImageService.preview(this.buildPreviewArray(mediaStrucure), {
        nzZIndex: 2147483646,
        nzZoom: 1,
        nzRotate: 0,
      });
    } else {
      this.Download(mediaStrucure);
    }
  }
  fileDownload(mediaStrucure: MediaStructure) {
    this.Download(mediaStrucure);
  }
  onSliderChange(value: any) {
    {
      this.size = value;
    }
  }
  ChangeRole(mediaStrucure: MediaStructure) {
    const startIndex = this.imagesMedia.findIndex(
      (x) => x.id === mediaStrucure.id
    );
    mediaStrucure.mustUpdate = true;
    for (let i = 0; i < this.imagesMedia.length; i++) {
      if (i !== startIndex) {
        const tmpImg = this.imagesMedia[i];
        const l1 = tmpImg.Roles.length;
        tmpImg.Roles = tmpImg.Roles.filter(
          (x) => !mediaStrucure.Roles.find((y) => x === y)
        );
        const l2 = tmpImg.Roles.length;
        if (l1 !== l2) {
          tmpImg.mustUpdate = true;
        }
      }
    }
  }
  onLinkDrawerClose() {

    this.drawerVisible = false;
  }
  uploadLink() {
    this.drawerVisible = true;
  }
  handleFileInput(event: any) {

    let files = event.target.files;
    const fileList: FileList = files;
    for (let i = 0; i < fileList.length; i++) {
      const tmpFile = fileList[i];
      const isImage = tmpFile.type.startsWith('image');
      const tmpMediaStructure: MediaStructure = {
        id: 'upload' + i,
        fileID: '',
        name: '',
        data: '',
        thumbData: '',
        previewData: '',
        type: tmpFile.type,
        originalName: tmpFile.name,
        extension: '',
        appInfo: 'excel',
        isUploading: true,
        AltText: '',
        width: 0,
        height: 0,
        FileSize: 0,
        mediaLink: '',
        isHidden: false,
        isLink: false,
        HightPercent: 0,
        TopPercent: 0,
        widthPercent: 0,
        leftPercent: 0,
        Roles: [],
      };

      // if (isImage) {
      //   this.imagesMedia.push(tmpMediaStructure);
      // } else {
      //   this.filesMedia.push(tmpMediaStructure);
      // }

      this.mediaStructures.push(tmpMediaStructure);
      this.upload(tmpMediaStructure, i, fileList[i], false);
    }
  }

  handleLinkInput() {
    const tmpMediaStructure: MediaStructure = {
      id: '0',
      fileID: '0',
      name: '',
      data: '',
      thumbData: this.mediaLink,
      previewData: '',
      type: 'link',
      originalName: this.linkTitle,
      extension: '',
      appInfo: this.linkType === 'I' ? 'Pic' : 'Vid',
      isUploading: true,
      AltText: this.linkTitle,
      width: this.size,
      height: this.size,
      FileSize: 0,
      mediaLink: this.mediaLink,
      isHidden: false,
      isLink: true,
      HightPercent: 100,
      TopPercent: 0,
      widthPercent: 100,
      leftPercent: 0,
      Roles: this.linkRols,
      CoverID: this.coverID,
      isImage: this.linkType === 'I' ? true : false,
      isVideo: this.linkType === 'V' ? true : false,
    };
    
    this.imagesMedia.push(tmpMediaStructure);
    this.mediaStructures.push(tmpMediaStructure);
    this.subscriptions.push(
      this.mediaService.uploadLink(tmpMediaStructure).subscribe((d: any) => {
        tmpMediaStructure.id = d.result.tmpUploadFile.id;
        tmpMediaStructure.fileID = d.result.tmpUploadFile.fileID;
        tmpMediaStructure.isUploading = false;
        this.drawerVisible = false;
        this.fileUploaded.emit(tmpMediaStructure);
      })
    );
  }
  handleCoverFileInput(files: any) {
    const tmpFile = files.target.files[0];
    const isImage = tmpFile.type.startsWith('image');
    if (!isImage) {
      return;
    }
    const tmpMediaStructure: MediaStructure = {
      id: 'upload' + 0,
      fileID: '',
      name: '',
      data: '',
      thumbData: '',
      previewData: '',
      type: tmpFile.type,
      originalName: tmpFile.name,
      extension: '',
      appInfo: 'excel',
      isUploading: true,
      AltText: '',
      width: 0,
      height: 0,
      FileSize: 0,
      mediaLink: '',
      isHidden: true,
      isLink: false,
      HightPercent: 0,
      TopPercent: 0,
      widthPercent: 0,
      leftPercent: 0,
      Roles: [],
    };
    this.ImagesCover.push(tmpMediaStructure);
    this.upload(tmpMediaStructure, 0, tmpFile, true);
  }

  upload(tmpMediaStructure: MediaStructure, idx: number, file: any, isCover: boolean) {

    tmpMediaStructure.Percent = 0;
    if (tmpMediaStructure.isImage) {
      // this.ReadFileData(file);
    }


    this.subscriptions.push(
      this.mediaService.upload(file, isCover, this.ObjectKey, this.ObjectType)
        .subscribe(
          (event: any) => {

            let key = `mediaStorge-${this.AttributeId}`;
            let storedMedia = JSON.parse(localStorage.getItem(key) || '[]');
            let uniqueIdCounter = 1;
            if (event.dbPath && event.dbPath.tmpUploadFile) {
              //delete event.dbPath.tmpUploadFile.data; 
              event.dbPath.tmpUploadFile.data = "";
              // event.dbPath.tmpUploadFile.id =  `${this.AttributeId}`; 
            }
            event.sourceIndex = idx;
            if (Array.isArray(storedMedia)) {
              storedMedia.push(event);
            } else {
              storedMedia = [event];
            }

            localStorage.setItem(key, JSON.stringify(storedMedia));
            if (event.type === HttpEventType.UploadProgress) {
              tmpMediaStructure.Percent = Math.round((100 * event.loaded) / event.total);
            } else {
              const tmpUploadFile = (event.body ?? event).dbPath.tmpUploadFile;
              tmpMediaStructure.isUploading = false;
              tmpMediaStructure.id = tmpUploadFile.id;
              tmpMediaStructure.fileID = tmpUploadFile.fileID;
              tmpMediaStructure.originalName = tmpUploadFile.name;
              tmpMediaStructure.type = tmpUploadFile.type;
              tmpMediaStructure.appInfo = tmpUploadFile.appInfo;
              tmpMediaStructure.thumbData = 'data:' + tmpMediaStructure.type + ';base64,' + tmpUploadFile.data;


              tmpMediaStructure.width = Number(tmpUploadFile.width);
              tmpMediaStructure.height = Number(tmpUploadFile.height);
              //tmpMediaStructure.fullPath = tmpUploadFile.fullPath;

              if (tmpMediaStructure.height >= tmpMediaStructure.width) {
                tmpMediaStructure.HightPercent = 100;
                tmpMediaStructure.widthPercent = (tmpMediaStructure.width * 100) / tmpMediaStructure.height;
                tmpMediaStructure.leftPercent = (tmpMediaStructure.HightPercent - tmpMediaStructure.widthPercent) / 2;
                tmpMediaStructure.TopPercent = 0;
              } else {
                tmpMediaStructure.widthPercent = 100;
                tmpMediaStructure.HightPercent = (tmpMediaStructure.height * 100) / tmpMediaStructure.width;
                tmpMediaStructure.TopPercent = (tmpMediaStructure.widthPercent - tmpMediaStructure.HightPercent) / 2;
                tmpMediaStructure.leftPercent = 0;
              }

              if (isCover) {
                this.covertUrl = tmpMediaStructure.thumbData;
                this.coverID = tmpMediaStructure.fileID;
              }
              // let addedImage = this.imagesMedia.findIndex(
              //   (x) => x.id === tmpMediaStructure.id
              // );
              // if (addedImage !== -1) {
              //   this.imagesMedia.splice(addedImage, 1);
              // }
              
              this.imagesMedia = [...this.imagesMedia, tmpMediaStructure];
              this.fileUploaded.emit(tmpUploadFile);

              // if (tmpUploadFile.code) {

              // this.mediaService.getMediaByCode(tmpUploadFile.code).pipe(
              // catchError(() => of(null)),
              // tap((blob) => {

              // if (blob) {
              // const path=this.productCatalogService.createImageUrl(blob);  
              // tmpMediaStructure.fullPath = path;
              // storedMedia[0].dbPath.tmpUploadFile.fullPath= path; }
              // })
              // ).subscribe();
              // }

              if (tmpUploadFile.code) {
                console.log('[INFO] tmpUploadFile.code exists:', tmpUploadFile.code);

                this.mediaService.getMediaByCode(tmpUploadFile.code).pipe(
                  catchError((err) => {
                    console.error('[ERROR] Failed to fetch media by code:', err);
                    return of(null);
                  }),

                  tap((blob) => {
                    

                    if (blob) {
                      
                      const path = this.productCatalogService.createImageUrl(blob);

                      tmpMediaStructure.fullPath = path;

                      const mediaItem = storedMedia[0];

                      const nestedObject = mediaItem.dbPath?.tmpUploadFile;

                      if (nestedObject && typeof nestedObject === 'object') {
                        nestedObject.fullPath = path;

                      }
                    }
                  })
                ).subscribe();
              }

            }
          },
          (err) => {
            tmpMediaStructure.Percent = 0;
            tmpMediaStructure.ErrorMessage = 'Could not upload the file: ' + file.name;
          }
        )
    );
  }

  ReadFileData(file: any) {
    const reader = new FileReader();

    reader.onload = this._handleReaderLoaded.bind(this);

    reader.readAsBinaryString(file);
  }
  _handleReaderLoaded(readerEvt: any) {
    const binaryString = readerEvt.target.result;
    this.base64Str = btoa(binaryString);
  }
  buildPreviewArray(mediaStrucure: MediaStructure) {
    const enlargPX = 1000;
    const images: NzImage[] = [];
    const startIndex = this.imagesMedia.findIndex(
      (x) => x.id === mediaStrucure.id
    );
    const mediaFullPath = mediaStrucure.fullPath;
    images.push({
      src: this.satitizer.bypassSecurityTrustUrl(
        mediaFullPath!
      ) as string,
      width: (mediaStrucure.widthPercent * enlargPX) / 100 + 'px',
      height: (mediaStrucure.HightPercent * enlargPX) / 100 + 'px',
      alt: 'ng-zorro',
    });
    for (let i = startIndex + 1; i < this.imagesMedia.length; i++) {
      if (!this.imagesMedia[i].isVideo) {
        images.push({
          src: this.imagesMedia[i].thumbData,
          width: (this.imagesMedia[i].widthPercent * enlargPX) / 100 + 'px',
          height: (this.imagesMedia[i].HightPercent * enlargPX) / 100 + 'px',
          alt: 'ng-zorro',
        });
      }
    }
    for (let i = 0; i < startIndex; i++) {
      if (!this.imagesMedia[i].isVideo) {
        images.push({
          src: this.imagesMedia[i].thumbData,
          width: (this.imagesMedia[i].widthPercent * enlargPX) / 100 + 'px',
          height: (this.imagesMedia[i].HightPercent * enlargPX) / 100 + 'px',
          alt: 'ng-zorro',
        });
      }
    }
    return images;
  }
  getYoutubeAPIEmedURL() {
    const tmpUrl = this.mediaLink;
    let vedioID = '';
    if (tmpUrl.indexOf('embed') !== -1) {
      const linkElements = tmpUrl.split('/');
      vedioID = linkElements[linkElements.length - 1];
    } else if (tmpUrl.indexOf('watch') !== -1) {
      const linkElements = tmpUrl.split('=');
      vedioID = linkElements[linkElements.length - 1];
      this.mediaLink = `https://www.youtube.com/embed/${vedioID}`;
    } else {
      vedioID = tmpUrl;
      this.mediaLink = `https://www.youtube.com/embed/${vedioID}`;
    }
    return vedioID;
  }
  getYouTubeInfo() {
    if (this.mediaLink === undefined || this.mediaLink === '') {
      return;
    }
    if (this.linkType === 'V') {
      const VideoID = this.getYoutubeAPIEmedURL();
    } else if (this.linkType === 'I') {
    }
  }
  YTDurationToHour(duration: any) {
    let match = duration.match(/PT(\d+H)?(\d+M)?(\d+S)?/);

    match = match.slice(1).map((x: any) => {
      if (x != null) {
        return x.replace(/\D/, '');
      }
    });

    // tslint:disable-next-line: radix
    const hours = parseInt(match[0]) || 0;
    // tslint:disable-next-line: radix
    const minutes = parseInt(match[1]) || 0;
    // tslint:disable-next-line: radix
    const seconds = parseInt(match[2]) || 0;

    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  trackByFn(index: number, item: MediaStructure): string {
    return item.id;
  }
  loadMediaFromLocalStorage(): void {

    let key = `mediaStorge-${this.AttributeId}`;
    const savedMedia = localStorage.getItem(key);
    if (savedMedia !== null) {
      const mediaStorge = JSON.parse(savedMedia);
      if (Array.isArray(mediaStorge) && mediaStorge.length > 0) {

        this.mediaStructures = [];
        this.imagesMedia = [];
        this.ImagesCover = [];
        this.filesMedia = [];
        mediaStorge.forEach(item => {

          if (item && item.dbPath && item.dbPath.tmpUploadFile) {

            const tmpUploadFile = item.dbPath.tmpUploadFile;
            tmpUploadFile.sourceIndex = item.sourceIndex;


            const id = item.dbPath.tmpUploadFile.id;
            tmpUploadFile.id = id.toString();

            const FileId = item.dbPath.tmpUploadFile.fileID;
            tmpUploadFile.fileID = FileId.toString();

            const Type = item.dbPath.tmpUploadFile.type;
            tmpUploadFile.type = Type;

            const AppInfo = item.dbPath.tmpUploadFile.appInfo;
            tmpUploadFile.appInfo = AppInfo;

            const Postion = item.dbPath.tmpUploadFile.Position;
            tmpUploadFile.Position = Number(Postion);

            const name = item.dbPath.tmpUploadFile.originalName;
            tmpUploadFile.originalName = name;
            const extension = item.dbPath.tmpUploadFile.extension;
            tmpUploadFile.extension = extension;
            //const data = item.dbPath.tmpUploadFile.data;
            //console.log('Modified data:', data);

            //tmpUploadFile.data = data !== undefined && data !== null ? data.toString() : '';

            // console.log('Updated data in loadMediaFromLocalStorage:', tmpUploadFile.data);

            const MediaLink = item.dbPath.tmpUploadFile.mediaLink;
            tmpUploadFile.mediaLink = MediaLink;

            const isLink = item.dbPath.tmpUploadFile.isLink;
            tmpUploadFile.isLink = Boolean(isLink);

            // if (!tmpUploadFile.isLink) {
            //   tmpUploadFile.thumbData = 'data:' + Type + ';base64,' + data;
            // } else {
            //   tmpUploadFile.thumbData = data;
            // }

            const size = item.dbPath.tmpUploadFile.FileSize;
            tmpUploadFile.FileSize = Number(size);

            const width = item.dbPath.tmpUploadFile.width;
            tmpUploadFile.width = Number(width);

            const Height = item.dbPath.tmpUploadFile.height;
            tmpUploadFile.height = Number(Height);

            const isHidden = item.dbPath.tmpUploadFile.isHidden;
            tmpUploadFile.isHidden = Boolean(isHidden);

            const isVideo = item.dbPath.tmpUploadFile.isVideo;
            tmpUploadFile.isVideo = Boolean(isVideo);

            const altText = item.dbPath.tmpUploadFile.AltText;
            tmpUploadFile.AltText = altText;

            tmpUploadFile.fullPath = item.dbPath.tmpUploadFile.fullPath;


            const Roles = item.dbPath.tmpUploadFile.Roles;
            if (Roles !== null && Roles !== undefined) {
              tmpUploadFile.Roles = Roles.split(',');
            }

            if (tmpUploadFile.height >= tmpUploadFile.width) {
              tmpUploadFile.HightPercent = 100;
              tmpUploadFile.widthPercent = (tmpUploadFile.width * 100) / tmpUploadFile.height;
              tmpUploadFile.leftPercent = (tmpUploadFile.HightPercent - tmpUploadFile.widthPercent) / 2;
              tmpUploadFile.TopPercent = 0;
            } else {
              tmpUploadFile.widthPercent = 100;
              tmpUploadFile.HightPercent = (tmpUploadFile.height * 100) / tmpUploadFile.width;
              tmpUploadFile.TopPercent = (tmpUploadFile.widthPercent - tmpUploadFile.HightPercent) / 2;
              tmpUploadFile.leftPercent = 0;
            }

            tmpUploadFile.Percent = 100;
            tmpUploadFile.isUploading = false;
            tmpUploadFile.isError = false;
            this.mediaStructures.push(tmpUploadFile);
          }
        });


        this.imagesMedia = this.mediaStructures.filter(
          (x) => (x.type.startsWith('image') || x.type.startsWith('link')) && x.isHidden !== true
        );

        this.filesMedia = this.mediaStructures.filter(
          (x) => !x.type.startsWith('image') && !x.type.startsWith('link') && x.isHidden !== true
        );

        this.ImagesCover = this.mediaStructures.filter(
          (x) => x.type.startsWith('image') && x.isHidden === true
        );
      }
    }
  }
  // resetMediaStorageKeys(): void {
  //   Object.keys(localStorage).forEach((key) => {

  //     if (key.startsWith('mediaStorge-')) {
  //       localStorage.removeItem(key);

  //     }
  //   });
  // }
  resetMediaStorageKeys(): void {

    for (const key of Object.keys(localStorage)) {
      if (key.startsWith('mediaStorge-')) {
        localStorage.removeItem(key);
        break;
      }
    }
  }
  override ngOnDestroy(): void {
    this.productCatalogService.revokeAll();
    super.ngOnDestroy();
  }
}
